import { render, staticRenderFns } from "./MainContainer.vue?vue&type=template&id=1555027b&scoped=true&"
import script from "./MainContainer.vue?vue&type=script&lang=ts&"
export * from "./MainContainer.vue?vue&type=script&lang=ts&"
import style0 from "./MainContainer.vue?vue&type=style&index=0&id=1555027b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1555027b",
  null
  
)

export default component.exports